import { Converter } from '../types/converter';

export const lengthConverter: Converter = {
  id: 'length',
  name: 'Length Converter',
  icon: 'Ruler',
  categories: ['common', 'engineering'],
  units: [
    // SI units
    { name: 'Meter', symbol: 'm', factor: 1 },
    { name: 'Kilometer', symbol: 'km', factor: 1000 },
    { name: 'Decimeter', symbol: 'dm', factor: 0.1 },
    { name: 'Centimeter', symbol: 'cm', factor: 0.01 },
    { name: 'Millimeter', symbol: 'mm', factor: 0.001 },
    { name: 'Micrometer', symbol: 'µm', factor: 1e-6 },
    { name: 'Nanometer', symbol: 'nm', factor: 1e-9 },
    { name: 'Picometer', symbol: 'pm', factor: 1e-12 },
    { name: 'Femtometer', symbol: 'fm', factor: 1e-15 },
    { name: 'Attometer', symbol: 'am', factor: 1e-18 },
    
    // Large SI units
    { name: 'Exameter', symbol: 'Em', factor: 1e18 },
    { name: 'Petameter', symbol: 'Pm', factor: 1e15 },
    { name: 'Terameter', symbol: 'Tm', factor: 1e12 },
    { name: 'Gigameter', symbol: 'Gm', factor: 1e9 },
    { name: 'Megameter', symbol: 'Mm', factor: 1e6 },
    { name: 'Hectometer', symbol: 'hm', factor: 100 },
    { name: 'Dekameter', symbol: 'dam', factor: 10 },
    
    // Imperial/US units
    { name: 'Mile', symbol: 'mi', factor: 1609.344 },
    { name: 'Mile (US survey)', symbol: 'mi (US)', factor: 1609.347219 },
    { name: 'Yard', symbol: 'yd', factor: 0.9144 },
    { name: 'Foot', symbol: 'ft', factor: 0.3048 },
    { name: 'Foot (US survey)', symbol: 'ft (US)', factor: 0.304800610 },
    { name: 'Inch', symbol: 'in', factor: 0.0254 },
    { name: 'Inch (US survey)', symbol: 'in (US)', factor: 0.0254000508 },
    { name: 'Mil', symbol: 'mil', factor: 0.0000254 },
    { name: 'Microinch', symbol: 'µin', factor: 0.0000000254 },
    
    // Astronomical units
    { name: 'Light Year', symbol: 'ly', factor: 9.461e15 },
    { name: 'Astronomical Unit', symbol: 'au', factor: 1.496e11 },
    { name: 'Parsec', symbol: 'parsec', factor: 3.086e16 },
    { name: 'Kiloparsec', symbol: 'kpc', factor: 3.086e19 },
    { name: 'Megaparsec', symbol: 'Mpc', factor: 3.086e22 },
    
    // Maritime units
    { name: 'Nautical Mile (International)', symbol: 'NM', factor: 1852 },
    { name: 'Nautical Mile (UK)', symbol: 'NM (UK)', factor: 1853.184 },
    { name: 'Fathom', symbol: 'fath', factor: 1.8288 },
    { name: 'Fathom (US survey)', symbol: 'fath (US)', factor: 1.8288036 },
    
    // Historical/Traditional units
    { name: 'League', symbol: 'lea', factor: 4828.032 },
    { name: 'Furlong', symbol: 'fur', factor: 201.168 },
    { name: 'Chain', symbol: 'ch', factor: 20.1168 },
    { name: 'Rod', symbol: 'rd', factor: 5.0292 },
    { name: 'Link', symbol: 'li', factor: 0.201168 },
    { name: 'Hand', symbol: 'hand', factor: 0.1016 },
    { name: 'Cubit (UK)', symbol: 'cubit', factor: 0.4572 },
    
    // Scientific units
    { name: 'Angstrom', symbol: 'Å', factor: 1e-10 },
    { name: 'Atomic Unit of Length', symbol: 'a.u.', factor: 5.29177210903e-11 },
    { name: 'X-unit', symbol: 'X', factor: 1.00208e-13 },
    { name: 'Fermi', symbol: 'F', factor: 1e-15 },
    { name: 'Planck Length', symbol: 'ℓP', factor: 1.616255e-35 },
    { name: 'Bohr Radius', symbol: 'a₀', factor: 5.29177210903e-11 },
    
    // Typographic units
    { name: 'Pica', symbol: 'pica', factor: 0.004233333 },
    { name: 'Point', symbol: 'pt', factor: 0.000352778 },
    { name: 'Twip', symbol: 'twip', factor: 0.0000176389 },
    
    // Historical units
    { name: 'Russian Archin', symbol: 'archin', factor: 0.7112 },
    { name: 'Vara Castellana', symbol: 'vara', factor: 0.835905 },
    { name: 'Greek Cubit', symbol: 'cubit (Greek)', factor: 0.4624 },
    { name: 'Roman Actus', symbol: 'actus', factor: 35.47872 },
    
    // Astronomical reference units
    { name: "Earth's Equatorial Radius", symbol: 'R⊕', factor: 6.378137e6 },
    { name: "Earth's Polar Radius", symbol: 'R⊕ₚ', factor: 6.356752e6 },
    { name: "Earth's Distance from Sun", symbol: 'AU-sun', factor: 1.496e11 },
    { name: "Sun's Radius", symbol: 'R☉', factor: 6.957e8 }
  ]
};
